import { render } from "./DProfessionSwitcher.vue?vue&type=template&id=a0829a08&scoped=true"
import script from "./DProfessionSwitcher.vue?vue&type=script&lang=js"
export * from "./DProfessionSwitcher.vue?vue&type=script&lang=js"

import "./DProfessionSwitcher.vue?vue&type=style&index=0&id=a0829a08&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0829a08"]])

export default __exports__